var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"headline text-uppercase"},[_vm._v(_vm._s(_vm.title))]),_c('br'),_c('span',{staticClass:"body-1"},[_vm._v(_vm._s(_vm.subtitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }